//nav-mobile-trigger

var hornstrup = hornstrup || {};

hornstrup.backgroundVideo = hornstrup.backgroundVideo || function () {
    var self = this;

    this.checkVideo = function (callback) {
        //hvis der er en video...
        if($('#hero .hero__bg-video:visible .data-video').length)
        {

            if(! $('#jumbotron-video').length){
                self.buildVideo();
            }


        }
    }


    this.buildVideo = function (callback) {
        var video = $('<video id="jumbotron-video" loop muted autoplay></video>');
        $('#hero .hero__bg-video .data-video').each(function(){
            var videoType=$('<source src="'+$(this).attr('data-src')+'" type="'+$(this).attr('data-type')+'">');
            $(video).append(videoType);
        });
        $('#hero .hero__bg-video').append($(video));
    }




    // public functions:
    return {
        checkVideo: checkVideo
    };
}();